import { getBffUrl as bffUrlSelector } from 'selectors'
import store from '../store'

import * as Api from '../utils/api'

const getBffUrl = () => bffUrlSelector(store.getState())

export const search = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists`, body
)

export const importJournalists = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/import`, body
)

export const findPublications = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/find_publications`, body
)

export const findArticles = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/find_articles`, body
)

export const suggest = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/suggestions`, body
)

export const fetchRecentContentFilters = () => Api.get(
  `${getBffUrl()}/contacts_management/journalists/content_filters/recent_contents`
)

export const filtersFromContents = body => Api.post(
  `${getBffUrl()}/contacts_management/journalists/content_filters`, body
)
